import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Card = styled.div`
	max-width: 45rem;
	transition: all 0.1s;

	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-2);
	}
`;

export const RightCol = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: space-between;
	overflow: auto;
`;
export const ImgContainer = styled.div`
	padding-right: var(--padding-2);
	body[dir='rtl'] & {
		padding-left: unset;
		padding-left: var(--padding-2);
	}
	position: relative;
`;

export const TitleCss = css`
	display: inline-block;
`;
export const TitleContainer = styled.div`
	display: flex;
	position: relative;
	justify-content: space-between;
	white-space: nowrap;
`;
export const BadgeCss = css`
	display: inline-block;
	font-size: var(--headerOne);
	background-color: var(--blue);
	color: var(--white) !important;
	justify-content: right;
	display: flex;
	font-weight: 500;
	padding: 0.2rem var(--padding-1);
	border-radius: 4px;
`;
export const Content = styled.div`
	position: relative;
	margin-top: 1rem;
	text-align: left;
`;
export const Link = styled.div`
	justify-content: right;
	display: flex;
	body[dir='rtl'] & {
		justify-content: left;
		> .typography > .icon {
			rotate: calc(180deg);
		}
	}
`;
